import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_24: FaireProductEntity = {
  token: "catalog_prod_prod-24",
  type: "product",
  name: "Party Plates - Cake Slice Design (Set of 8) - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  priceDollars: 21.46,
  msrpDollars: 53.65,
  sku: "CO0024",
  caseSize: 6,
  material: "Cotton",
  collectionToken: "col_confetti-cake",
  categoryTokens: ["catalog_cat_cats"],
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 128,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
